export type TabsPermissions<TabId extends string> = Record<TabId, boolean>;

export type PermittedData<T = unknown> = T & {permitted: boolean};

export enum EntityType {
	Student = 'student',
	ClassGroup = 'class-group'
}
